<template>
    <div>
        <b-modal id="modal-prevent-closing" no-close-on-backdrop hide-footer ref="modal-create-update-class-school"
            @hidden="resetModal">

            <div class="container wrap-form-create-update-chapter">
                <h4>
                    <strong>{{ getNameTitle }}</strong>
                </h4>
                <b-form id="form-create-update-chapter" @submit.prevent="handleSave">
                    <div class="row form-group pb-2">
                        <div class="col-md-12">
                            <div class="login-modal__form__item display-block">
                                <label for="name">Tên bài giảng:</label>
                                <b-form-input id="name" v-model="form.name" type="text" placeholder="Nhập tên bài giảng"
                                    autocomplete="off" class="form-control" />
                                <span class="error display-block color-err font-size-14 text-left"
                                    v-if="!$v.form.name.required && submitted">
                                    Vui lòng nhập tên bài giảng
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row form-group pb-2">
                        <div class="col-md-12">
                            <div class="login-modal__form__item display-block display-flex">
                                <label for="name">Loại bài giảng:</label>
                                <div class="wrap-input">
                                    <b-form-select @change="handleOnChangeTypeDocument" v-model="form.typeDocument"
                                        :options="listTypeDocument" class="">
                                        <option value="">Chọn để tiếp tục</option>
                                    </b-form-select>
                                    <span class="error display-block color-err font-size-14 text-left"
                                        v-if="!$v.form.name.required && submitted">
                                        Vui lòng nhập loại bài giảng
                                    </span>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="row form-group pb-2">
                        <div class="col-md-12">
                            <input hidden type="file" name="file" id="fileInputUpload" class="hidden-input"
                                @change="onChangeUploadFile" ref="file" :accept="[form.typeDocument == TYPE_H5P ? '.h5p' : '.pptx,.docx,.xlsx,.pdf,.h5p']" />
                            <div v-if="!(form.file || form.fileName) && (form.typeDocument == TYPE_H5P || form.typeDocument == TYPE_DOCUMENT)"
                                class="login-modal__form__item display-block">
                                <div @dragover="dragoverUploadFile" @dragleave="dragleaveUploadFile"
                                    @drop="dropUploadFile"
                                    class="wrap-upload-file display-flex justify-content-space-between"
                                    :class="isDragging ? 'upload-drag' : ''">
                                    <div class="upload-file-left">
                                        <img class="icon-upload" src="@/assets/img/upload.png" />
                                    </div>
                                    <div class="upload-file-center">
                                        <div><strong>Thêm hoặc kéo thả</strong></div>
                                        <div>
                                            {{ form.typeDocument == TYPE_H5P ? 'Chỉ hỗ trợ định dạng .h5p' : 'Hỗ trợ các định dạng .pptx, .docx, .xlsx, .pdf' }}
                                        </div>
                                        <div>
                                            Mỗi lần chỉ tải 1 file, dung lượng file không vượt quá 15MB
                                        </div>
                                    </div>
                                    <div class="upload-file-right">
                                        <button @click="onUploadFile" type="button"
                                            class="btn btn-upload border-rd-20 font-size-16 form-30h font-sanpro-semibold display-flex-center justify-content-center line-height-1">
                                            CHỌN FILE
                                        </button>
                                    </div>

                                </div>
                                <span class="error display-block color-err font-size-14 text-left"
                                    v-if="!$v.form.fileName.required && submitted">
                                    Vui lòng chọn file tài liệu
                                </span>
                            </div>

                            <div v-else-if="(form.file || form.fileName) && (form.typeDocument == TYPE_H5P || form.typeDocument == TYPE_DOCUMENT)"
                                class="display-block">
                                <label for="name">File bài giảng:</label>
                                <div class="wrap-file-data display-flex justify-content-space-between">

                                    <div class="wrap-left display-flex">
                                        <img class="icon-photo" src="@/assets/img/photo.png" />
                                        <div class="name-file">
                                            {{ form.file ? form.file.name : form.fileName }}
                                        </div>
                                    </div>
                                    <div class="wrap-right display-flex">
                                        <div class="size-file">{{ formatSizeFile(form.sizeFile) }}</div>
                                        <img @click="handleOnRemoveFile" class="btn-delete"
                                            src="@/assets/img/icon-close.png" />
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div v-if="form.typeDocument == FILE_YOUTUBE || form.typeDocument == FILE_CANVA || form.typeDocument == FILE_LINK"
                        class="row form-group pb-2">
                        <div class="col-md-12">
                            <div class="login-modal__form__item display-block">
                                <label for="path">Link tài liệu:</label>
                                <input id="path" v-model="form.link" type="text" placeholder="link tài liệu"
                                    autocomplete="off" class="form-control" />
                                <span class="error display-block color-err font-size-14 text-left"
                                    v-if="!$v.form.link.required && submitted">
                                    Vui lòng nhập link tài liệu
                                </span>
                            </div>
                        </div>
                    </div>
                    <div v-if="form.typeDocument == TYPE_TEST" class="row form-group pb-2">
                        <div class="col-md-12">
                            <div class="login-modal__form__item display-block">
                                <label for="name">Sau khi cập nhật, cần tạo câu hỏi cho bài kiểm tra</label>

                            </div>
                        </div>
                    </div>
                    <div class="row form-group pb-2">
                        <div class="col-md-12">
                            <div class="login-modal__form__item display-block">
                                <label @click="isOpenModalView = true" class="instructions">Hướng dẫn tạo bài giảng</label>
                                <ModalViewInformation @closeModal="isOpenModalView = false" v-if="isOpenModalView" />
                            </div>
                        </div>
                    </div>
                    <div class="form_action display-flex justity-content-center cg-1">
                        <button type="button"
                            class="btn border-rd-20 font-size-16 form-30h font-sanpro-semibold display-flex-center justify-content-center line-height-1"
                            :disabled="isLoading" @click="handleHideModal">
                            Hủy
                        </button>
                        <button type="submit"
                            class="btn btn-main border-rd-20 font-size-16 form-30h font-sanpro-semibold display-flex-center justify-content-center line-height-1"
                            :disabled="isLoading || form.typeDocument == ''">
                            {{ getNameCommit }}
                        </button>
                    </div>
                </b-form>
            </div>

        </b-modal>
    </div>
</template>
<script>
import { required, requiredIf } from 'vuelidate/lib/validators';
import { saveDocumentClassSchool, getDetail } from './../../../_api/documentClassSchoolServices'
import { TYPE_H5P, TYPE_DOCUMENT, TYPE_TEST, FILE_YOUTUBE, FILE_CANVA, FILE_LINK,REFERENCE_LECTURE } from './../../../constants/constants_enum'
import ModalViewInformation from '../ModalViewInformation.vue';


export default {
    components: {
        ModalViewInformation
    },
    props: {
        chapterId: {
            type: Number,
            default: 0
        },
        postId: {
            type: Number,
            default: 0
        },
        documentId: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            confirmActive: {},
            submitted: false,
            isLoading: false,
            form: {
                id: 0,
                lessonClassSchoolId: 0,
                chapterId: 0,
                postId: 0,
                name: '',
                typeDocument: '',
                fileName: '',
                pathFile: '',
                link: '',
                sizeFile: 0,
                file: null, //lưu trữ file upload
            },
            isOpenModalView: false,
            isDragging: false,
            TYPE_H5P, TYPE_DOCUMENT, TYPE_TEST, FILE_YOUTUBE, FILE_CANVA, FILE_LINK,
            REFERENCE_LECTURE,
            listTypeDocument: [
                { value: TYPE_H5P, text: 'Bài giảng tương tác H5P' },
                { value: REFERENCE_LECTURE, text: 'Bài giảng tham khảo lấy từ thư viện' },
                { value: TYPE_DOCUMENT, text: 'Dạng tài liệu' },
                { value: TYPE_TEST, text: 'Dạng kiểm tra' },
                { value: FILE_YOUTUBE, text: 'Dạng youtube' },
                { value: FILE_CANVA, text: 'Dạng canva' },
                { value: FILE_LINK, text: 'Dạng nhúng' },
            ]
        }
    },
    validations() {
        return {
            form: {
                name: {
                    required
                },
                typeDocument: {
                    required
                },
                fileName: { required: requiredIf(() => (this.form.typeDocument == TYPE_H5P || this.form.typeDocument == TYPE_DOCUMENT)) },
                link: { required: requiredIf(() => (this.form.typeDocument == FILE_LINK || this.form.typeDocument == FILE_CANVA || this.form.typeDocument == FILE_YOUTUBE)) }
            }
        }
    },
    computed: {
        screenWidth() {
            return window.innerWidth;
        },
        getNameTitle() {
            return this.documentId == 0 ? 'Thêm bài giảng' : 'Cập nhật bài giảng'
        },
        getNameCommit() {
            return this.form.typeDocument == TYPE_TEST ? 'Tiếp tục' : (this.documentId > 0 ? 'Cập nhật' : 'Thêm mới')
        },
    },
    mounted() {
        this.form.lessonClassSchoolId = this.$route.query.id
        this.form.chapterId = this.chapterId
        this.form.postId = this.postId
        if (this.documentId > 0) {
            //get detail
            this.getDetailDocumentClassSchool()
        }
        this.handleShowModal()
    },
    methods: {
        getDetailQuestion() {
            let self = this
            getDetail(this.documentId).then(res => {
                if (res && res.data && !res.errors) {
                    this.form = {
                        id: res.data.id,
                        lessonClassSchoolId: res.data.lessonClassSchoolId,
                        topicName: res.data.topicName, // tên đề bài

                        //sizeImage: 1, // kích cỡ ảnh
                        withSize: res.data.withSize,
                        heightSize: res.data.heightSize,
                        fileQuestion: {
                            fileData: null,
                            url: res.data.path ? `${this.cdnUrl}${res.data.path}` : '',
                        },
                        content: res.data.content,
                        listAnswer: []
                    }
                    //set data cho sizeImage
                    for (let i = 0; i < this.question_img_size.length; i++) {
                        const item = this.question_img_size[i];
                        if (item.text == `${this.form.withSize}x${this.form.heightSize}`) {
                            this.form.sizeImage = item.value
                            break
                        }
                    }
                    if (res.data.listLessonAnswerClassSchoolModels.length == 0) {
                        this.form.listAnswer.push(this.answerDefault())
                    }

                    for (let i = 0; i < res.data.listLessonAnswerClassSchoolModels.length; i++) {
                        const item = res.data.listLessonAnswerClassSchoolModels[i];
                        this.form.listAnswer.push({
                            id: item.id,
                            idClient: this.generateUUID(),
                            isTrue: item.isTrue,
                            content: item.content,
                            fileAnswer: {
                                fileData: null,
                                url: item.path ? `${this.cdnUrl}${item.path}` : '',
                            },
                        })
                    }


                }
            })
        },
        handleOnChangeTypeDocument() {
            this.handleOnRemoveFile()
            this.form.link = ''
        },
        handleOnRemoveFile() {
            this.$refs.file.value = '';
            this.form.file = null
            this.form.pathFile = ''
            this.form.fileName = ''
            console.log('clear')
        },
        formatSizeFile(data, to = 'MB') {
            const const_term = 1024;

            // Convert the values and concatenate 
            // the appropriate unit 
            if (to === "KB") {
                return (data / const_term).toFixed(3) + "KB";
            } else if (to === "MB") {
                return (data / const_term ** 2).toFixed(3) + "MB";
            } else if (to === "GB") {
                return (data / const_term ** 3).toFixed(3) + "GB";
            } else if (to === "TB") {
                return (data / const_term ** 4).toFixed(3) + "TB";
            } else {
                return "";
            }
        },
        onUploadFile() {
            this.$refs.file.click()
        },
        onChangeUploadFile() {
            const const_term = 1024;
            var listTypeDocument = ['pptx', 'docx', 'xlsx', 'pdf'];
            if (this.form.typeDocument == TYPE_H5P) listTypeDocument = ['h5p'];
            var checkType = false
            if (this.$refs.file.files[0].size / const_term ** 2 <= 15) {
                for (let i = 0; i < listTypeDocument.length; i++) {
                    if (this.$refs.file.files[0].name.split(".").pop() == listTypeDocument[i]) {
                        this.form.file = this.$refs.file.files[0]
                        this.form.sizeFile = this.form.file.size
                        this.form.fileName = this.form.file.name
                        // console.log(this.$refs.file.files[0].size)
                        checkType = true
                    }
                }
                if (!checkType) {
                    if (this.form.typeDocument == TYPE_H5P) {
                        this.$toast.error('Chỉ hỗ trợ định dạng .h5p')
                    }
                    else {
                        this.$toast.error('Chỉ hỗ trợ các định dạng .docx, .pptx, .pdf, .xlsx')
                    }
                }
            } else {
                this.$toast.error('Upload file có dung lượng không quá 15MB')
            }

        },
        dropUploadFile(e) {
            e.preventDefault();
            this.$refs.file.files = e.dataTransfer.files;
            this.onChangeUploadFile();
            this.isDragging = false;
        },
        dragoverUploadFile(e) {
            e.preventDefault();
            this.isDragging = true;
        },
        dragleaveUploadFile() {
            this.isDragging = false;
        },
        getDetailDocumentClassSchool() {
            // form: {
            //     id: 0,
            //     lessonClassSchoolId: 0,
            //     chapterId: 0,
            //     postId: 0,
            //     name: '',
            //     typeDocument: '',
            //     path: '',
            //     file:null//lưu trữ file upload
            // },
            let self = this
            getDetail(this.documentId).then(res => {
                if (res && res.data && !res.errors) {

                    self.form = {
                        id: res.data.id,
                        lessonClassSchoolId: res.data.lessonClassSchoolId,
                        chapterId: res.data.chapterId,
                        postId: res.data.postId,
                        name: res.data.name,
                        typeDocument: res.data.typeDocument,
                        sizeFile: res.data.sizeFile,
                        fileName: res.data.fileName
                    }
                    if (self.form.typeDocument == TYPE_H5P || res.data.typeDocument == TYPE_DOCUMENT) {
                        self.form.pathFile = res.data.path
                    }
                    else {
                        self.form.link = res.data.path
                    }
                }
            })
        },
        handleSave() {
            // form: {
            //     id: 0,
            //     lessonClassSchoolId: 0,
            //     chapterId: 0,
            //     postId: 0,
            //     name: '',
            //     typeDocument: '',
            //     path: '',
            //     file:null//lưu trữ file upload
            // },
            let self = this
            this.submitted = true
            if (!this.$v.$invalid) {

                
                const formData = new FormData();
                formData.append('id', this.form.id);
                formData.append('lessonClassSchoolId', this.form.lessonClassSchoolId);
                formData.append('chapterId', this.form.chapterId);
                formData.append('postId', this.form.postId);
                formData.append('name', this.form.name);
                formData.append('typeDocument', this.form.typeDocument);
                formData.append('sizeFile', this.form.sizeFile);

                if (this.form.typeDocument == TYPE_H5P || this.form.typeDocument == TYPE_DOCUMENT) {
                    formData.append('path', this.form.pathFile);
                }
                else {
                    formData.append('path', this.form.link);
                }
                formData.append('fileName', this.form.fileName);
                if (this.form.file) {
                    formData.append('sizeFile', this.form.sizeFile);
                }
                formData.append('file', this.form.file);
                if(self.form.typeDocument == REFERENCE_LECTURE){
                    this.$emit('handleShowModalLectureLibrary',this.form)
                    return
                }
                saveDocumentClassSchool(formData).then(res => {
                    if (res && res.data && !res.errors) {
                        if (this.form.id > 0) {
                            self.$toast.success('Cập nhật bài giảng thành công')
                        } else {
                            self.$toast.success('Thêm mới bài giảng thành công')
                        }
                        if (self.form.typeDocument == TYPE_TEST) {
                            console.log(res.data)
                            self.handleDoneModalPrepareQuestions(res.data.id, res.data.name)
                        }
                        else {
                            self.handleDone()
                        }


                    }
                })
            }
        },
        resetModal() {
            this.submitted = false
            this.form = {
                id: 0,
                lessonClassSchoolId: 0,
                chapterId: 0,
                postId: 0,
                name: '',
                typeDocument: '',
                fileName: '',
                path: '',
                sizeFile: 0,
                file: null//lưu trữ file upload
            }
        },
        handleDoneModalPrepareQuestions(id, name) {
            this.handleHideModal()
            let params = {
                id: id,
                name: name
            }
            this.$emit('handleDoneModalPrepareQuestions', params)
        },
        handleDone() {
            this.handleHideModal()
            this.$emit('handleDone')
        },
        toggleModal() {
            // We pass the ID of the button that we want to return focus to
            // when the modal has hidden
            this.$refs['modal-create-update-class-school'].toggle('#toggle-btn')
        },
        handleHideModal() {
            //this.$refs['modal-create-update-class-school'].hide()
            this.$emit('closeModal')
        },
        handleShowModal() {
            this.$refs['modal-create-update-class-school'].show()
        },
    }
}
</script>
<style lang="scss" scoped>
.upload-drag {
    border: 2px dashed #46b5e1 !important;
    opacity: 0.5;
}
.instructions{
    color: blue;
    cursor: pointer;
}
.wrap-file-data {
    .wrap-left {
        .name-file {
            max-width: 285px;
            text-overflow: ellipsis;
            overflow: hidden;
            margin-left: 5px;
        }

        .icon-photo {
            width: 30px;
        }
    }

    .wrap-right {
        .size-file {
            margin-right: 5px;
            color: #7a7777;
        }

        .btn-delete {
            cursor: pointer;
            width: 20px;
            height: 20px;
        }
    }
}

.wrap-upload-file {
    border: 1px dashed #c8c8c8;
    padding: 10px;
    border-radius: 15px;

    .upload-file-left {
        min-width: 50px;

        .icon-upload {
            width: 30px;
        }
    }

    .upload-file-right {
        .btn-upload {
            background: white;
            border: 2px solid #59b7df;
            color: #59b7df;
            min-width: 110px;
        }
    }
}

.wrap-input {
    margin-left: 10px;
    width: 75%;
}

.wrap-form-create-update-chapter {
    background-color: white;
}

.justify-content-space-between {
    justify-content: space-between
}

.justify-content-center {
    justify-content: center
}
</style>
